<script lang="ts">
  import Typography from "./../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";

  export let label: string;
  export let isDisabled: boolean = false;
  export let value: boolean | string = false;
  export let onChange: (value: boolean) => void = () => {
    "do nothing";
  };

  let clazz = "";
  export { clazz as class };

  const toggleValue = () => {
    if (isDisabled) return;
    value = !value;
    onChange(value);
  };
</script>

<button
  on:click={toggleValue}
  class={`w-full ${clazz || ""}`}
  class:cursor-pointer={!isDisabled}
  class:cursor-not-allowed={isDisabled}
  {...$$restProps}>
  <div class="radio-container flex gap-3 w-full items-center">
    <div
      class="min-w-6 min-h-6 border-0 border-gray-300 rounded-full flex items-center justify-center"
      class:not-selected={!value}
      class:selected={!!value}>
      <div class="w-3 h-3 bg-white rounded-full" class:not-selected={!value}></div>
    </div>

    <p class="text-left">
      <Typography
        mobile={TypographyType.Headline3}
        desktop={TypographyType.Headline5}
        --font-color="var(--color-grayscale-black)">
        {label}
      </Typography>
    </p>
  </div>
</button>

<style>
  .not-selected {
    background: var(--color-grayscale-30);
  }

  .selected {
    background: var(--color-purple-50);
  }
</style>
